module.exports = __webpack_public_path__ + "img/logo-bordered.924517aa.png";